var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pdv-layout"
  }, [_vm.mostrarTopbar ? _c('header', {
    staticClass: "pdv-layout__topbar"
  }, [_c('div', {
    staticClass: "pdv-layout__topbar-left"
  }, [_c('img', {
    staticClass: "pdv-layout__logo",
    attrs: {
      "src": "media/brand/logo.png",
      "alt": "PDV Desktop"
    }
  }), _vm.terminalNome ? _c('div', {
    staticClass: "pdv-layout__terminal-info"
  }, [_c('span', {
    staticClass: "pdv-layout__terminal-name"
  }, [_vm._v(_vm._s(_vm.terminalNome))]), _vm.serie ? _c('span', {
    staticClass: "pdv-layout__serie"
  }, [_vm._v("Série " + _vm._s(_vm.serie))]) : _vm._e()]) : _vm._e()]), _c('div', {
    staticClass: "pdv-layout__topbar-right"
  }, [_vm.isDashboard ? _c('span', {
    class: ['pdv-layout__status', _vm.online ? 'pdv-layout__status--online' : 'pdv-layout__status--offline']
  }, [_c('span', {
    staticClass: "pdv-layout__status-dot"
  }), _vm._v(" " + _vm._s(_vm.online ? "Online" : "Offline") + " ")]) : _vm._e(), _vm.isDashboard ? _c('button', {
    staticClass: "pdv-layout__settings-btn",
    attrs: {
      "title": "Configurações do terminal"
    },
    on: {
      "click": _vm.abrirConfiguracoesDashboard
    }
  }, [_c('i', {
    staticClass: "fas fa-cog"
  })]) : _vm._e(), _vm.nomeUsuario ? _c('span', {
    staticClass: "pdv-layout__usuario-nome"
  }, [_c('i', {
    staticClass: "fas fa-user-circle"
  }), _vm._v(" " + _vm._s(_vm.nomeUsuario) + " ")]) : _vm._e(), !_vm.isDashboard ? _c('button', {
    staticClass: "pdv-layout__back-btn",
    on: {
      "click": _vm.voltarDashboard
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-left mr-1"
  }), _vm._v(" Dashboard ")]) : _vm._e(), _c('button', {
    staticClass: "pdv-layout__logout-btn",
    attrs: {
      "title": "Sair do PDV"
    },
    on: {
      "click": _vm.sair
    }
  }, [_c('i', {
    staticClass: "fas fa-sign-out-alt"
  }), _vm._v(" Sair ")])])]) : _vm._e(), _c('main', {
    staticClass: "pdv-layout__main"
  }, [_c('router-view')], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };